// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Je","landingPageVideo":"Ke","play":"Le","iframeVideo":"Me","playHidden":"Ne","playVisible":"Oe","fullwidth":"Pe"};